export const isMobile = '(max-width: 600px)';
export const isDesktop = '(min-width: 601px)';
export const isLargeDesktop = '(min-width: 960px)';
export const untilLargeDesktop = '(max-width: 960px)';
